<ion-header>
  <ion-toolbar>
    <ion-row class="enter-tag-id-modal__header">
      <ion-col size="10">
        <div class="enter-tag-id-modal__title">{{ title }}</div>
      </ion-col>
      <ion-col size="2" class="ion-text-right" style="cursor: pointer">
        <img (click)="closeModal()" src="assets/common/cross.svg" />
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row class="enter-tag-id-modal__content">
      <ion-col>
        <ion-input
          [type]="inputType"
          (keyup.enter)="save()"
          [(ngModel)]="input"
          [placeholder]="placeHolder"
        ></ion-input>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer [translucent]="true">
  <ion-toolbar>
    <ion-grid class="enter-tag-id-modal__footer">
      <ion-row class="ion-justify-content-end">
        <ion-col size="auto">
          <ui-custom-button
            [buttonType]="'SECONDARY'"
            [btnTxt]="'common.cancel' | translate"
            (clickEvent)="closeModal()"
          ></ui-custom-button>
        </ion-col>
        <ion-col size="0.5"></ion-col>
        <ion-col class="edit-efficiency__edit-save" size="auto">
          <ui-custom-button
            [btnTxt]="'common.ok' | translate"
            [isDisabled]="!(input.length > 0)"
            (clickEvent)="save()"
          ></ui-custom-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
